import React from 'react';

const Loder = () => {
    return (
        <div className='justify-center align-middle '>
            <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin dark:border-emerald-400"></div>
        </div>
    );
};

export default Loder;